"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpreadsheetCell = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var core_1 = require("@newfront-insurance/core");
var core_ui_1 = require("@newfront-insurance/core-ui");
var kebabCase_1 = __importDefault(require("lodash/kebabCase"));
var react_1 = __importStar(require("react"));
var _1 = require(".");
function SpreadsheetCell(_a) {
    var _b, _c, _d;
    var cell = _a.cell, row = _a.row, index = _a.index, onCellClick = _a.onCellClick, _e = _a.cellBackground, cellBackground = _e === void 0 ? '#fff' : _e, propTestId = _a.testId;
    var cellRef = (0, react_1.useRef)(null);
    var _f = (0, react_1.useState)(false), isOpen = _f[0], setIsOpen = _f[1];
    var style = row.canExpand ? { background: core_ui_1.colors.steel[50], cursor: 'pointer' } : { background: cellBackground };
    var toggleRowExpandedProps = row.canExpand ? row.getToggleRowExpandedProps() : {};
    var columnTitle = (_b = cell.column.title) !== null && _b !== void 0 ? _b : (typeof cell.column.render('Header') === 'string' ? (_c = cell.column.render('Header')) === null || _c === void 0 ? void 0 : _c.toString() : undefined);
    var columnTestId = (_d = cell.column.testId) !== null && _d !== void 0 ? _d : ((0, core_1.isNotUndefined)(columnTitle) ? (0, kebabCase_1.default)(columnTitle) : undefined);
    var cellId = (0, core_1.isNotUndefined)(columnTestId) ? "".concat(row.id, "-").concat(columnTestId) : undefined;
    return (react_1.default.createElement(react_1.Fragment, { key: index },
        react_1.default.createElement(_1.Cell, __assign({}, cell.getCellProps(), { ref: cellRef, index: index, sticky: cell.column.sticky, focusable: cell.column.focusable, tabIndex: cell.column.focusable ? 0 : undefined, onClick: function () { return onCellClick(row.original, cell.value, cell.column.id, index); }, onChangeFocus: function () { return setIsOpen(false); }, onEnter: function () { return setIsOpen(true); }, onDoubleClick: function (e) {
                if (cell.column.focusable) {
                    setIsOpen(true);
                }
            } }, toggleRowExpandedProps, { style: __assign(__assign({}, cell.getCellProps().style), style), "data-column-label": cell.column.Header, "data-column-id": cell.column.id, testId: (0, core_ui_1.generateTestId)(propTestId, cellId) }),
            cell.render('Cell'),
            cell.render('CellPopover', {
                cellRef: cellRef,
                isOpen: isOpen,
                close: function () {
                    var _a;
                    setIsOpen(false);
                    (_a = cellRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                },
            }))));
}
exports.SpreadsheetCell = SpreadsheetCell;
